import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';

const FloatRequestConfirmed = () => {
	return (
		<>
			<Navbar />
			<div className="min-h-full flex justify-center items-center bg-black text-white container">
				<div className="issue-card-container container">
					<div className="flex flex-col text-center">
						<h2>Float Invoice Request Confirmed</h2>
					</div>
					<div className="bulk-card-body" style={{ textAlign: 'center', fontSize: 20, lineHeight: 1.5, marginTop: 70 }}>
						Your Float Invoice request has been sent to our Finance Team for processing.<br />
						<br />
						Please allow 2 business days for your invoice to be emailed.
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default FloatRequestConfirmed;
